import { LionSelect } from "@lion/select";
import { css } from "lit";
import { LdsBaseInputMixin } from "../../../legl-ui/lds-input";

export class LdsSelect extends LdsBaseInputMixin(LionSelect) {
  static get styles() {
    return [
      super.styles,
      css`
                .input-group__container
                    > .input-group__input
                    ::slotted(.form-control) {
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    background-color: #ffffff;
                    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.8805 9.29006L12.0005 13.1701L8.12047 9.29006C7.73047 8.90006 7.10047 8.90006 6.71047 9.29006C6.32047 9.68006 6.32047 10.3101 6.71047 10.7001L11.3005 15.2901C11.6905 15.6801 12.3205 15.6801 12.7105 15.2901L17.3005 10.7001C17.6905 10.3101 17.6905 9.68006 17.3005 9.29006C16.9105 8.91006 16.2705 8.90006 15.8805 9.29006Z' fill='%2342516E'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    background-position: calc(100% - 10px) 13px;
                    width: 100%;
                    text-overflow: ellipsis;
                    padding-right: 28px;
                    white-space: nowrap;
                }

                :host([small])
                    .input-group__container
                    > .input-group__input
                    ::slotted(.form-control) {
                    background-position: calc(100% - 6px) 4px;
                }
            `,
    ];
  }
}

customElements.define("lds-select", LdsSelect);
